import { render, staticRenderFns } from "./button-global-player.vue?vue&type=template&id=3e5bcb70&"
import script from "./button-global-player.js?vue&type=script&lang=js&"
export * from "./button-global-player.js?vue&type=script&lang=js&"
import style0 from "./button-global-player.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports